var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stepper-wrapper mx-5 px-3"},[_c('div',{staticClass:"stepper-item"},[_c('div',{staticClass:"step-counter"},[_vm._v("1")])]),_c('div',{staticClass:"stepper-item"},[_c('div',{staticClass:"step-counter"},[_vm._v("2")])]),_c('div',{staticClass:"stepper-item"},[_c('div',{staticClass:"step-counter"},[_vm._v("3")])])])
}]

export { render, staticRenderFns }